export default window.boot || {};
